import React from 'react';
import '../../assets/styles/Popup.css';
import { appConfig } from '../../appConfig';

const Popup = ({ show, handleClose, children, popUpHeading, popupType }) => {
  const { Popup } = appConfig;

  return (
    <div className={`popup ${show ? 'show' : ''}`}>
      <div className="popup-inner">
        <div className={`card ${popupType === "coverage" ? "coverage-popup" : ""}`}>
          <div className="card-header text-center">
            {popUpHeading}
          </div>

          <div className="card-body overflow-auto">
            {children}
          </div>

          <div className="card-footer d-flex justify-content-end">
            <button
              className="btn btn-danger close-btn ms-auto"
              onClick={handleClose}
            >
              {Popup.closeButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;

